import { RouteConfig } from 'vue-router'

import {
	AssistancesIndex
} from '@/views'

const assistanceRouter: Array<RouteConfig> = [
	{
        path: 'assistances',
        name: 'assistances',
        component: AssistancesIndex,
        meta: {
            requiresVisitor: false,
            requiresAuth: true,
            title: 'Asistencias'
        }
    }
]

export default assistanceRouter
